var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7H15.5C14.673 7 14 6.327 14 5.5V2H6V18H18V7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.00003V5.70703L15 2.70703V5.50003C15 5.77503 15.225 6.00003 15.5 6.00003H18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.707 5L15 1.293C14.8125 1.10545 14.5582 1.00006 14.293 1H6C5.73478 1 5.48043 1.10536 5.29289 1.29289C5.10536 1.48043 5 1.73478 5 2V18C5 18.2652 5.10536 18.5196 5.29289 18.7071C5.48043 18.8946 5.73478 19 6 19H18C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18V5.707C18.9999 5.4418 18.8946 5.18749 18.707 5ZM18 5.707V6H15.5C15.3675 5.99974 15.2404 5.94697 15.1467 5.85326C15.053 5.75955 15.0003 5.63253 15 5.5V2.707L18 5.707ZM6 2.2V17.8C6 17.91 6.09 18 6.2 18H17.8C17.853 18 17.9039 17.9789 17.9414 17.9414C17.9789 17.9039 18 17.853 18 17.8V7H15.5C15.1022 7 14.7206 6.84196 14.4393 6.56066C14.158 6.27936 14 5.89782 14 5.5V2H6.2C6.14696 2 6.09609 2.02107 6.05858 2.05858C6.02107 2.09609 6 2.14696 6 2.2Z",
    fill: "#605E5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 12H13.5C13.775 12 14 12.225 14 12.5C14 12.775 13.775 13 13.5 13H12.5C12.3675 12.9997 12.2404 12.947 12.1467 12.8533C12.053 12.7596 12.0003 12.6325 12 12.5C12 12.225 12.225 12 12.5 12ZM15.5 12H16.5C16.775 12 17 12.225 17 12.5C17 12.775 16.775 13 16.5 13H15.5C15.3675 12.9997 15.2404 12.947 15.1467 12.8533C15.053 12.7596 15.0003 12.6325 15 12.5C15 12.225 15.225 12 15.5 12Z",
    fill: "#D12232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 10H13.5C13.775 10 14 10.225 14 10.5C14 10.775 13.775 11 13.5 11H12.5C12.3675 10.9997 12.2404 10.947 12.1467 10.8533C12.053 10.7596 12.0003 10.6325 12 10.5C12 10.225 12.225 10 12.5 10ZM15.5 10H16.5C16.775 10 17 10.225 17 10.5C17 10.775 16.775 11 16.5 11H15.5C15.3675 10.9997 15.2404 10.947 15.1467 10.8533C15.053 10.7596 15.0003 10.6325 15 10.5C15 10.225 15.225 10 15.5 10Z",
    fill: "#F13748"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8H15.5C15.225 8 15 8.225 15 8.5C15 8.775 15.225 9 15.5 9H16.5C16.775 9 17 8.775 17 8.5C17 8.225 16.775 8 16.5 8Z",
    fill: "#EC6572"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8H12.5C12.225 8 12 8.225 12 8.5C12 8.775 12.225 9 12.5 9H13.5C13.775 9 14 8.775 14 8.5C14 8.225 13.775 8 13.5 8Z",
    fill: "#F13748"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H10C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V7C11 6.73478 10.8946 6.48043 10.7071 6.29289C10.5196 6.10536 10.2652 6 10 6H2C1.73478 6 1.48043 6.10536 1.29289 6.29289C1.10536 6.48043 1 6.73478 1 7V15C1 15.2652 1.10536 15.5196 1.29289 15.7071C1.48043 15.8946 1.73478 16 2 16Z",
    fill: "#D12232"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60602 14L8.31302 8H7.15002L3.39502 14H4.60602Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37397 14L3.66797 8H4.82997L8.58397 14H7.37397Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.99e24d462dbbe6402a307765845da844.svg";
export { ForwardRef as ReactComponent };